module.exports = __webpack_public_path__ + "static/media/Background.158b40c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Background.png
// module id = 74
// module chunks = 0